/**
 * ScenarioBanner - Indicador flotante de modo Planificación
 *
 * @version 1.0
 * @updated 2026-02-18
 * @module core/layouts
 *
 * @description
 * Banner fijo sobre el mapa que indica que hay un escenario activo.
 * Aparece cuando el usuario activa un escenario desde ScenariosPanel.
 * Al cerrar, emite el evento `scenario-deactivated`.
 */

import { X, GitBranch } from 'lucide-react';
import type { Scenario, ScenarioType } from '../scenarios';
import './scenario-banner.css';

const TYPE_LABELS: Record<ScenarioType, string> = {
  baseline:    'Base',
  proposed:    'Propuesta',
  sensitivity: 'Sensibilidad',
};

interface ScenarioBannerProps {
  scenario: Scenario;
}

export function ScenarioBanner({ scenario }: ScenarioBannerProps): JSX.Element {
  const handleExit = (): void => {
    window.dispatchEvent(new CustomEvent('scenario-deactivated'));
  };

  return (
    <div className="scenario-banner">
      <div className="scenario-banner-inner">
        <GitBranch size={14} className="scenario-banner-icon" />
        <span className="scenario-banner-mode">PLANIFICACIÓN</span>
        <span className="scenario-banner-sep" aria-hidden>·</span>
        <span className="scenario-banner-name">{scenario.name}</span>
        <span className={`scenario-banner-type type-${scenario.type}`}>
          {TYPE_LABELS[scenario.type]}
        </span>
        {scenario.version > 1 && (
          <span className="scenario-banner-version">v{scenario.version}</span>
        )}
        <button
          className="scenario-banner-exit"
          onClick={handleExit}
          title="Salir del modo planificación"
        >
          <X size={12} />
          Salir
        </button>
      </div>
    </div>
  );
}
